<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IuN4xY/tc-custom/9781639550647.jpg?1726519363268" alt="This image is the cover for the book Perma Red"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Perma Red
      </h1>
      <p class="bookDescription body article font2">
        <p>Bold, passionate, and more urgent than ever, Debra Magpie Earling’s powerful classic novel is reborn in this new edition.     On the Flathead Indian Reservation, summer is ending, and Louise White Elk is determined to forge her own path. Raised by her Grandmother Magpie after the death of her mother, Louise and her younger sister have grown up into the harsh social and physical landscape of western Montana in the 1940s, where Native people endure boarding schools and life far from home. As she approaches adulthood, Louise hopes to create an independent life for herself and an improved future for her family—but three persistent men have other plans.     Since childhood, Louise has been pursued by Baptiste Yellow Knife, feared not only for his rough-and-tumble ways, but also for the preternatural gifts of his bloodline. Baptiste’s rival is his cousin, Charlie Kicking Woman: a man caught between worlds, torn between his duty as a tribal officer and his fascination with Louise. And then there is Harvey Stoner. The white real estate mogul can offer Louise her wildest dreams of freedom, but at what cost?                                                                                                   As tensions mount, Louise finds herself trying to outrun the bitter clutches of winter and the will of powerful men, facing choices that will alter her life—and end another’s—forever.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Debra Magpie Earling
      </h2>
      
      <p class="authorDescription body article"><P><B>Debra Magpie Earling</B> is the author of <I>Perma Red </I>and <I>The</I><I>Lost Journals of Sacajewea</I>. An earlier version of the latter, written in verse, was produced as an artist book during the bicentennial of the Lewis and Clark expedition. She has received both a National Endowment for the Arts grant and a Guggenheim Fellowship. She retired from the University of Montana where she was named professor emeritus in 2021. She is Bitterroot Salish.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Milkweed Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?56ebab67